module.exports = __webpack_public_path__ + "img/detail-table-icon.a52a9273.svg";